module.exports = __webpack_public_path__ + "img/ic_feedback_shared.8827d6d5.png";